import { RouteRecordRaw, RouteRecordRedirect } from "vue-router";
import { checkCompletedRegister } from "./guards/checkCompletedRegister";

export const redirects: RouteRecordRaw = {
  path: "",
  component: () =>
    import(/* webpackChunkName: "debug" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "/check-completed-register",
      name: "CheckCompletedRegister",
      beforeEnter: checkCompletedRegister
    } as RouteRecordRedirect
  ]
};
